const TASK_COMMON_API = {
  EXCEPTION_LOG_API: '/config/exception_log',
  INTERACTIVE_AD_API: '/config/banner',
};

export default TASK_COMMON_API;
